'use client';

import React from 'react';
import styles from './ProfileTotals.module.css';

interface ProfileTotalsProps {
  totalTokensPurchased: number;
  totalReferralBonusTokens: number;
  grandTotalTokens: number;
  isLoading: boolean;
}

const StatCard: React.FC<{ title: string; value: string | number; isLoading: boolean; dataTestId?: string }> = ({ title, value, isLoading, dataTestId }) => {
  return (
    <div className={styles.statCard} data-testid={dataTestId}>
      <h3 className={styles.statTitle}>{title}</h3>
      {isLoading ? (
        <div className={styles.loadingSpinnerSmall}></div>
      ) : (
        <p className={styles.statValue}>{typeof value === 'number' ? value.toLocaleString(undefined, { maximumFractionDigits: 2 }) : value}</p>
      )}
    </div>
  );
};

const ProfileTotals: React.FC<ProfileTotalsProps> = ({ 
  totalTokensPurchased,
  totalReferralBonusTokens,
  grandTotalTokens,
  isLoading
}) => {
  return (
    <div className={`${styles.profileTotalsContainer} ${styles.glassmorphism} ${styles.bentoItem}`} data-testid="profile-totals-container">
      <StatCard 
        title="Tokens Purchased"
        value={totalTokensPurchased}
        isLoading={isLoading} 
        dataTestId="tokens-purchased-stat"
      />
      <StatCard 
        title="Referral Bonuses"
        value={totalReferralBonusTokens}
        isLoading={isLoading}
        dataTestId="referral-bonuses-stat"
      />
      <StatCard 
        title="Grand Total Tokens"
        value={grandTotalTokens}
        isLoading={isLoading}
        dataTestId="grand-total-tokens-stat"
      />
    </div>
  );
};

export default ProfileTotals; 